'use client';

import { useState } from 'react';

type State = { kind: 'idle' | 'sending' | 'done' | 'error'; message?: string };

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [trap, setTrap] = useState('');
  const [state, setState] = useState<State>({ kind: 'idle' });

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setState({ kind: 'sending' });
    try {
      const res = await fetch('/api/email-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'footer-newsletter', company_website: trap }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data?.success !== false) {
        setState({ kind: 'done', message: 'Thank you — you’re on the list.' });
        setEmail('');
      } else {
        setState({ kind: 'error', message: 'We couldn’t sign you up just now. Please try again later.' });
      }
    } catch {
      setState({ kind: 'error', message: 'We couldn’t sign you up just now. Please try again later.' });
    }
  }

  if (state.kind === 'done') {
    return <p className="font-al-display text-2xl text-al-gold" role="status">{state.message}</p>;
  }

  return (
    <form onSubmit={onSubmit} className="w-full lg:justify-self-end lg:max-w-lg">
      <div className="flex flex-col gap-3 sm:flex-row">
        <label htmlFor="al-newsletter" className="sr-only">Email address</label>
        <input
          id="al-newsletter"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="al-field flex-1"
        />
        {/* honeypot */}
        <input type="text" tabIndex={-1} autoComplete="off" value={trap} onChange={(e) => setTrap(e.target.value)} className="hidden" aria-hidden="true" />
        <button type="submit" className="al-btn-primary" disabled={state.kind === 'sending'}>
          {state.kind === 'sending' ? 'Joining…' : 'Subscribe'}
        </button>
      </div>
      {state.kind === 'error' && <p className="mt-3 text-sm text-al-rose" role="alert">{state.message}</p>}
    </form>
  );
}
